function getVideoSerie(step, id_company) {

	$.ajax({
        localCache: true,
		cacheTTL: 0.5,
		url: URL_API + "/collection/?f=get_collection&step=" + step,
		cache: false,
		success: function (json) {
			var objJson = JSON.parse(json);

			for (var i = 0; i < objJson.length; i++) {
				$('.summaryListVideo').append('<div class="horizontalVideoGrid" id="liveHorizontalList' + step + '-' + i + 'Box"><a onclick="openSerieThumb(' + objJson[i].id + ');"><h4 id="liveHorizontalList' + step + '-' + i + 'Title" class="title-last-media"> ' + objJson[i].title + ' <span class="horizontalBrowserAll"><i class="ri-arrow-right-s-line"></i></span></h4></a> <div id="liveHorizontalList' + step + '-' + i + '" ></div></div>');
				getContentsHorizontal(URL_API + "/video/?f=get_video&collection=" + objJson[i].id, 1, "#liveHorizontalList" + step + "-" + i);
			}
			if (objJson.length > 0) {
				step++;
				getVideoSerie(step, id_company);
			}
		}
	});
}


function showCompletedSeries() {
	BSLight.ModalShow('#modal_completed_series');

	$(".modalCompletedSeries").html("");
	loadCompletedSeries(1);
}

var stepHomepageSections = 1;
var semapWindowsScrollHomepage = 0;
var jsonHomepage = '';
var lastScrollTopHomepageSections = 0;
// solo l'ultima richiesta renderizza: risposte arrivate fuori ordine (es. home
// user dopo una pagina custom aperta da deep-link) vengono scartate. Solo web:
// sulle app native resta il comportamento storico
var homepageSectionsRequestId = 0;

function loadHomepageSections(type, company, isEditor = 0, version = null, page = null, idCustom = null) {
    let requestId = ++homepageSectionsRequestId;

    $('.standardHome').html('<div id="loading_results_spinner" class="col-md-12 text-center row"><svg id="" class="circularLoading" height="50" width="50"><circle class="path" cx="25" cy="25.2" r="19.9" fill="none" stroke-width="6" stroke-miterlimit="10" /></svg></div>');
    
	console.log("load home");
	let strVersion = '';
	if (!!version) {
		strVersion = '&version=' + version;
	}

	let strPage = '';
	if (!!page) {
		strPage = '&page=' + page;
	}

	let strIdCustom = '';
	if (!!idCustom) {
		strIdCustom = '&id_custom=' + idCustom;
	}
    
	$.ajax({
        localCache: true,
		cacheTTL: 1,
		type: 'GET',
		url: URL_API + '/landing/?f=get_homepage_settings&type=' +
			type +
			'&id=' +
			company +
			'&editor_mode=' +
			isEditor +
			strVersion +
			strPage +
			strIdCustom,
		success: function (json) {
            if (window.TY_WEB && requestId !== homepageSectionsRequestId) { return; }
            $('.standardHome').html('');

			jsonHomepage = JSON.parse(json);
			// console.log(jsonHomepage);

			if (!jsonHomepage.content) {
                localStorage.clear();
			}

			// console.log(jsonHomepage.content);

			for (let i = 0; jsonHomepage.content.length > i; i++) {
				let counterSum = i + 1;
				// console.log(i);
				$('.standardHome').append(
					'<section id="positionSection' +
					counterSum +
					'" class="sectionHomePageElement"></section>'
				);
			}
			generateHomepageSections(jsonHomepage, stepHomepageSections);
			createScrollHomepage(
				jsonHomepage,
				semapWindowsScrollHomepage,
				stepHomepageSections
			);
		},
        error: function(){
            localStorage.clear();
        }
	});
}


function createScrollHomepage(json, semapWindowsScrollHomepage, stepHomepageSections) {
	// $(window).off('scroll');
 
 
 onscrolleventbackup_home = function () {
    // namespace: un solo gestore progressivo attivo. Con la home smontata e
    // ri-renderizzata (navigateToPage) i closure con json superati non devono
    // restare agganciati a generare sezioni doppie
    $(document).off('scroll.tyhomeprog').on('scroll.tyhomeprog', function () {
        // alert(currentPageState[currentPageState.length-1]);
        // anche le pagine custom ('page-<id>') sono renderizzate nel contenitore della home
        var currentState = currentPageState[currentPageState.length-1];
        var isHomeLayer = currentState == 'home' || String(currentState).indexOf('page-') === 0;
        if(!isHomeLayer || semapWindowsScrollHomepage == 1){
            // alert("fermo");
            // se mi trovo non in home o ho temrinato di scrollare la home, fermo tutto
            return false;
        }
        // alert("we");
        stepHomepageSections++;
        generateHomepageSections(json, stepHomepageSections);
        if (stepHomepageSections == json.content.length) {
            semapWindowsScrollHomepage = 1;
        }
        
    });

    }

    onscrolleventbackup_home();

}

// $(document).ready(function () {
// 	$('#backFromSearch').click(function (e) {

// 		$('#mainLiveHome').html('');
// 		$(".headerSearchGlobalInput").val('');
// 		// $(".headerSearchGlobalInput").removeClass("siteSearchHover");

// 		$('.sectionContainer').show();
// 		$('.searchHome').hide();

// 		createScrollHomepage(jsonHomepage, semapWindowsScrollHomepage, lastScrollTopHomepageSections, stepHomepageSections);
// 	 });
// });
// typeHomepage 0 => homepage guest
// typeHomepage 1 => homepage registered
function generateHomepageSections(json, step) {
	let objJson = json;
	let elementToAppend = 5;
	let calcStepStart = (step - 1) * elementToAppend;
	let calcStepEnd = calcStepStart + 5;
	if (objJson.content.length < calcStepEnd) {
		calcStepEnd = objJson.content.length;
	}
	if (calcStepStart > calcStepEnd) {
		$(window).off('scroll');
	}


	for (let i = calcStepStart; calcStepEnd > i; i++) {
        if (objJson.content[i].type) {
            	// console.log("4");
            let pos = i + 1;
            updateSection(objJson.content[i], pos);
        }
	}
}


function generateCollectionSpotlight(res){

   let collectioInformation = generateCollectionInfo(res);

    //compantibilità call
    if(res.image_background){
        res.img_preview_background = res.image_background;
    }
    if(res.image){
        res.img_preview = res.image;
    }
    if(res.image_logo_title){
        res.img_preview_logo_title = res.image_logo_title;
    }
    //

    var reminder_obj = '';
    if (res.saved == true) {
        reminder = "<i class='ri-check-line'></i>"+ translate('SAVED');
    } else {
        reminder = "<i class='ri-add-line'></i> "+ translate('REMIND_ME');
    }
    
    reminder_obj = '<span onclick="event.stopPropagation();openModalSetSavedContent(' + res.id + ',\'serie\');" class="button-secondary button-small controlSetLikeSerie reminder_serie' + res.id + '">' + reminder + '</span>';
    var watchNowBtn = '';
    if (res.next_video_play && res.next_video_play.id) {
        watchNowBtn = `<span class="button-primary button-small mr-1" onclick="event.stopPropagation();openWatchNowFromHome(${res.next_video_play.id});"><i class="ri-play-fill"></i> ${translate('WATCH_NOW')}</span>`;
    }
    
   return `<div class="collection-spotlight-content" onclick="openSerieThumb(${res.id});">              
            <img src="${res.img_preview_background ? res.img_preview_background : res.img_preview}" 
            onerror="this.onerror=null;this.src='img/void1px.png';"
            width="100%" style="position: relative; z-index: 0; -webkit-mask-image: -webkit-gradient(linear, left top, left bottom, color-stop(60%,rgba(0,0,0,1)), to(rgba(0,0,0,0)));">
            <div class="mb-1 text-center" style="position: relative; margin-top: -50px; z-index: 1 !important; opacity: 1 !important;">
                <div class="mb-1 text-center">
                ${(!companyThumbShowTitle && res.img_preview_logo_title) || res.img_preview_logo_title ? `<img onerror="this.onerror=null;this.src='img/void1px.png';" src="${res.img_preview_logo_title}" class="collectionLogoTitle">` : `<p class="bold white">${res.title}</p>`}
                </div>
                <div class="mt-1">
                    ${collectioInformation}
                </div>
                <div class="mt-1">
                    ${watchNowBtn}
                    ${reminder_obj}
                </div>
            </div>
        </div>`;
        
}

function updateSection(json, i) {
	// console.log("update section", json);
	$("#positionSection" + i).html("");

	//	console.log(json);
	//	console.log("pos: "+i);
	let sectionType = json.type;
	//	console.log(sectionType);
	let htmlFinal = '';
	let background = '';
	let mode = 'text-center';
	let title = '';
	let description = '';
	let CallToAction = '';
	let urlCallToAction = '';
	let categoriesParam = '';
	let category = '';
	let tag = '';
	let isParent = '';
	let callToAction = '';
	let backgroundVideo = '';
	let idSeries = '';
	let modeInputPosition = '';


	if (sectionType == 'header_slideshow_serie') {

        let topPositionCustom = '';
        if(i==1){
            topPositionCustom = 'top-position-custom';
        }

		$('#positionSection' + i).html('<div class="headerSectionSlider '+topPositionCustom+' headerSectionSlider' + i + '"></div>');

		if (json.val.id_cat) {
			categoriesParam = "&cat=" + json.val.id_cat;
		}

		let autoplayClass = '';
		let autoplayAttr = '';
		if(json.val.autoplay == "true"){
			// autoplayClass = 'slider-nav-autoplay';
			// autoplayAttr = 'data-slider-nav-autoplay-interval="5000"';
		}

		$.ajax({
			type: "GET",
			localCache: true,
			cacheTTL: 0.5,
			url: json.endpoint,
			success: function (responseSeries) {
				htmlFinal = '<div class="sliderHome sliderHome' + i + '"><div class="swiffy-slider slider-nav-sm slider-indicators-round slider-indicators-sm slider-nav- slider-nav-autohide '+autoplayClass+'" '+autoplayAttr+'><ul class="slider-container">';
				let seriesJson = JSON.parse(responseSeries);
				seriesJson = seriesJson.contents;
				if (seriesJson.length > 0) {
					for (let z = 0; seriesJson.length > z; z++) {
						htmlFinal += generateCollectionSpotlight(seriesJson[z]);
					}

					let sliderIndicator = '';
					for (let z = 0; (seriesJson.length - 1) > z; z++) {
						sliderIndicator += '<button></button>';
					};

					htmlFinal += '</ul><div class="slider-indicators"><button class="active"></button>' + sliderIndicator + '</div></div>';
					// $('#positionSection'+i).append('</div>');

					//glow ambientale con l'immagine della prima slide dietro allo slider
					let glowSrc = seriesJson[0].image_background || seriesJson[0].img_preview_background || seriesJson[0].image || seriesJson[0].img_preview;
					if (glowSrc) {
						htmlFinal = '<img class="home-ambient-glow" src="' + glowSrc + '" onerror="this.remove();" alt="">' + htmlFinal;
					}

				} else {
					$('#positionSection'+i).remove();
				}

                $('.headerSectionSlider' + i).html(htmlFinal);

                try{
                    let currentSlid = document.querySelector('.headerSectionSlider' + i + ' .swiffy-slider');
                    swiffyslider.initSlider(currentSlid);
                }catch(err){}

			}
		});

	} else if (sectionType == 'video') {

		// let height = "50vh";
		// if (json.val.mode == 'full') {
		// 	height = "100vh";
		// }

		// htmlFinal = `<div style="width:100%; height:${height};">`;

		// if (json.val.id != '') {
		// 	htmlFinal += `<iframe loading="lazy" id="" allowfullscreen="true" autoplay webkitallowfullscreen="true" mozallowfullscreen="true" frameborder="0" height="100%" width="100%" src="${URL_PLAYER}/video/player?w=${json.val.id}&auto=on" scrolling="no"></iframe>`;
		// }
		// htmlFinal += '</div>';

		// $('#positionSection' + i).append(htmlFinal);

	} else if (sectionType == 'collection_spotlight') {
        

        let topPositionCustom = '';
        if(i==1){
            topPositionCustom = 'top-position-custom';
        }

		// $('#positionSection' + i).html('<div class="collection-spotlight '+topPositionCustom+'"></div>');

		let finalCSHtml = "";
		if (json.val.id != '') {

			$.ajax({
				localCache: true,
				cacheTTL: 1,
				type: "GET",
				url: URL_API2 + "/collections/" + json.val.id,
				success: function (result) {
					var res = JSON.parse(result);
					finalCSHtml = generateCollectionSpotlight(res);

					//glow ambientale con l'immagine della collection dietro allo spotlight
					let glowSrc = res.image_background || res.img_preview_background || res.image || res.img_preview;
					if (glowSrc) {
						finalCSHtml = '<img class="home-ambient-glow" src="' + glowSrc + '" onerror="this.remove();" alt="">' + finalCSHtml;
					}

					$('#positionSection' + i).html('<div class="collection-spotlight '+topPositionCustom+'">'+finalCSHtml+'</div>');
				}
			});
		}

	} else if (sectionType == 'list_pack') {
		// let titleSection = getCurrentStringML(json.val.title_section, currentLang);
		// if (json.val.id_cat) {
		// 	if (Array.isArray(json.val.id_cat)) {
		// 		categoriesParam = "&cat=" + json.val.id_cat[0];
		// 		category = json.val.id_cat[0];
		// 	} else {
		// 		categoriesParam = "&cat=" + json.val.id_cat;
		// 		category = json.val.id_cat;
		// 	}
		// }
		// htmlFinal = '<div class="horizontalVideoGrid" id="liveHorizontalListPack' + i + 'Box" ><h4 id="liveHorizontalListPack' + i + 'Title" class="serie_title_main">' + titleSection + '</h4><div id="liveHorizontalListPack' + i + '" class="liveHorizontalListVideo"></div></div>';
		// $('#positionSection' + i).append(htmlFinal);
		// getContentsHorizontal(URL_API + "/collection/?f=get_collection&parent=1" + categoriesParam, 1, "#positionSection" + i);

	} else if (sectionType == 'list_serie') {
		titleSection = json.val.title_cat;
		if (json.val.title_section) {
			titleSection = getCurrentStringML(json.val.title_section, currentLang);
		}
		clickCategories = '';
		if (json.val.id_cat) {
			if (Array.isArray(json.val.id_cat)) {
				if ((json.val.id_cat).length > 0) {
					categoriesParam = "&cat=" + json.val.id_cat[0];
					category = json.val.id_cat[0];
				}
			} else {
				categoriesParam = "&cat=" + json.val.id_cat;
				category = json.val.id_cat;
			}

			var tagsParam = '';
			if (json.val.tags) {
				if (Array.isArray(json.val.tags)) {
					if ((json.val.tags).length > 0) {
						tagsParam = "&tags=" + json.val.tags[0];
						tag = json.val.tags[0];
					}
				} else {
					tagsParam = "&tags=" + json.val.tags;
					tag = json.val.tags;
				}
			}


			clickCategories = '<span class="horizontalBrowserAll"><i class="ri-arrow-right-s-line"></i></span>';
		}


		let mode = "";
		if (json.val.mode) {
			mode = json.val.mode;
		}

		let numbered = "";
		if (json.val.numbered) {
			numbered = json.val.numbered;
		}


		let cover = "";
		if (json.val.cover) {
			cover = json.val.cover;
		}

		htmlFinal = `<div class="horizontalVideoGrid" id="liveHorizontalListSerie${i}Box">
        <h4 onclick="clickedBrowseAll('${category.replace(/'/g, "\\'")}', '${tag.replace(/'/g, "\\'")}', '${titleSection.replace(/'/g, "\\'")}', true, 'get_collection');" 
            class="serie_title_main" 
            id="liveHorizontalListSerie${i}Title" 
            class="title-last-media">
            ${titleSection}${clickCategories}
        </h4>
        <div class="liveHorizontalListVideo" id="liveHorizontalListSerie${i}"></div>
        </div>`;
		$('#positionSection' + i).append(htmlFinal);
		getContentsHorizontal(json.endpoint, 1, "#positionSection" + i, mode, numbered, cover);

	} else if (sectionType == 'list_premium_contents') {

		// let overlayColor = "";
		// if (json.val.overlayColor) {
		// 	overlayColor = "background:linear-gradient(" + replaceAll(json.val.overlayColor, ";", ",") + ")!important;";
		// }


		// $('#positionSection' + i).append('<div style="' + overlayColor + '" class="container list_premium_contents list_premium_contents' + i + '"><div class="text-center premiumContentsTitleBox"><h1 class="white premiumContentsTitleBoxLabel">' + getCurrentStringML(json.val.title, currentLang) + '</h1><p class="white pHomeStandard">' + getCurrentStringML(json.val.description, currentLang) + '</p></div></div>');

		// let options =
		// {
		// 	"showImage": json.val.showImage
		// };

		// getListPricing('.list_premium_contents' + i,
		// 	URL_API + '/collection/?f=get_payment_preview',
		// 	options);

	} else if (sectionType == 'list_categories') {
		// let titleListCategories = getCurrentStringML(json.val.title, currentLang);
		// let modeCategories = json.val.mode;
		// let show_title = json.val.show_title;
		// let image = json.val.image;
		// let classContainer = '';
		// let classImage = '';
		// let classImageClickbox = '';
		// $('#positionSection' + i).html('<div class="listCategories listCategories' + i + '"></div>');

		// $.ajax({
		// 	type: "GET",
		// 	url: URL_API + "/categories/?f=get_categories&show=1&image=1",
		// 	success: function (json) {
		// 		if (json) {
		// 			let obj = JSON.parse(json);
		// 			let resultLength = obj.length;
		// 			for (let k = 0; k < resultLength; k++) {
		// 				if (k == 0) {

		// 					htmlFinal += '<h4 class="serie_title_main">' + titleListCategories + '</h4><div class="sectionHomeListCategories sectionHomeListCategories' + i + '  ' + classContainer + '"><div class="swiffy-slider responsive-slide-movie slider-item-snapstart slider-nav-noloop slider-nav-sm slider-nav-autohide slider-nav-page"><ul class="slider-container">';
		// 				}

		// 				if (image != 'show') {
		// 					classImage = 'class="grid-item"';
		// 				} else {
		// 					classImage = 'class="image-grid-cover"  style="background-image: url(' + obj[k].image + ');"';

		// 					try {
		// 						if (show_title == "show") {
		// 							classImageClickbox = 'image-grid-clickbox';
		// 						}
		// 					} catch (error) {

		// 					}

		// 				}

		// 				let titleCat = '';
		// 				try {
		// 					if (show_title == "show") {
		// 						titleCat = '<span class="cover-wrapper">' + getCurrentStringML(obj[k].name, currentLang) + '</span>';
		// 					}
		// 				} catch (error) {
		// 					// titleCat='';
		// 				}

		// 				htmlFinal += '<li><div onclick="clickedBrowseAll(' + obj[k].id + ', \'\', \'' + titleCat + '\');" class="image-grid-item"><div ' + classImage + '><span  class="' + classImageClickbox + '"></span>' + titleCat + '</div></div></li>';


		// 				if (k == resultLength - 1) {
		// 					//  console.log("stampo tutto");
		// 					//  console.log(htmlFinal);
		// 					htmlFinal += '</ul><button type="button" class="slider-nav"></button><button type="button" class="slider-nav slider-nav-next"></button></div></div>';
		// 					$("#positionSection" + i + " .listCategories").append(htmlFinal);


		// 					try {
		// 						// if (modeCategories == 'horizontal') {


		// 						let currentSlid = document.querySelector('#positionSection' + i + ' .swiffy-slider');
		// 						swiffyslider.initSlider(currentSlid);

		// 						// }
		// 					} catch (e) {
		// 						console.log("error-no-mode-present", e)
		// 					}

		// 				}

		// 			}
		// 		}
		// 	}
		// });

	} else if (sectionType == 'list_video' && (!!json.val.tag && json.val.tag != '-')) {

		let tagsParam = "";
		if (json.val.tags) {
			tagsParam = "&tags=" + json.val.tags;
		}

		var title_section = "Tag " + json.val.tag;
		if (json.val.title_section) {
			title_section = json.val.title_section;
			title_section = getCurrentStringML(title_section, currentLang);
		}

		htmlFinal = '<div class="horizontalVideoGrid" id="liveHorizontalListVideo' + i + 'Box" ><h4 id="liveHorizontalListVideoTitle" class="serie_title_main">' + title_section + '</h4><div class="liveHorizontalListVideo" id="liveHorizontalListVideo' + i + '"></div></div>';
		$('#positionSection' + i).append(htmlFinal);

		getContentsHorizontal(json.endpoint, 1, "#positionSection" + i);

	} else if (sectionType == 'list_video' && (json.val.id == 'keep_watching' || json.val.id == 'live_now' || json.val.id == 'live_scheduled' || json.val.id == '')) {

		valUrl = '';
		titleUrl = '';
		if (json.val.id == 'keep_watching') {
			valUrl = "get_video&option=keep_watching";
			titleUrl = translate('KEEP_WATCHING');
		}
		if (json.val.id == 'live_now') {
			valUrl = "get_video&option=live_now";
			titleUrl = translate('LIVE_NOW');
		}

		if (json.val.id == 'live_scheduled') {
			valUrl = "get_video&option=live_scheduled";
			titleUrl = translate('SCHEDULED');
		}
		if (json.val.id == '') {
			valUrl = "get_video&public=1";
			titleUrl = translate('LATEST_VIDEO');
		}
		idSeries = json.val.id;
		if (json.val.title_section) {
			titleUrl = json.val.title_section;
			titleUrl = getCurrentStringML(titleUrl, currentLang);
		}

		htmlFinal = '<div class="horizontalVideoGrid" id="liveHorizontalListVideo' + i + 'Box" ><h4 id="liveHorizontalListVideoTitle" class="serie_title_main"> ' + titleUrl + '</h4><div class="liveHorizontalListVideo" id="liveHorizontalListVideo' + i + '"></div></div>';
		$('#positionSection' + i).append(htmlFinal);

		let tagsParam = "";
		if (json.val.tags) {
			tagsParam = "&tags=" + json.val.tags;
		}

		getContentsHorizontal(json.endpoint, 1, "#positionSection" + i);

	} else if (sectionType == 'list_video' && isNaN(json.val.id) === false && !!json.val.id) {
		titleSection = getCurrentStringML(json.val.title_section, currentLang);


		idSeries = json.val.id;
		let idSerieParam = '';
		if (json.val.id) {
			idSerieParam = "&collection=" + json.val.id;
		}

		let tagsParam = "";
		if (json.val.tags) {
			tagsParam = "&tags=" + json.val.tags;
		}
		$('#positionSection' + i).append('<div class="horizontalVideoGrid" id="liveHorizontalListVideo' + i + 'Box" > <a onclick="openSerieThumb(' + idSeries + ');"><h4 id="liveHorizontalListVideoTitle" class="serie_title_main">' + titleSection + '<span class="horizontalBrowserAll"> <i class="ri-arrow-right-s-line"></i></span></h4></a><div class="liveHorizontalListVideo" id="liveHorizontalListVideo' + i + '"></div></div>');
		getContentsHorizontal(json.endpoint, 1, "#positionSection" + i);
    }
    // 'list_short' (feature Shorts rimossa): tipo sezione ignorato senza errore
}

$(document).ready(function () {
	// sul web ?idc= compare anche nei deep-link del checkout (/checkout/cart):
	// lì lo instrada js/web.js, qui si apre la collection solo dalla radice
	let idc = getUrlParameter('idc');
	if(idc && !(window.TY_WEB && window.location.pathname !== '/')){
		openSerieThumb(idc);
	}
});

function startFirstSerieVideoHome(id, idCollection) {
    var isNativeRuntime = !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
    var isGuestUser = (typeof userData === 'undefined' || !userData || userData.status != 'success');
    if (isNativeRuntime && isGuestUser) {
        openModalLogin();
        return false;
    }

	if (id) {
		location.href = "/video?w=" + id;
	} else {
		location.href = "/register?ref=/browse#idc=" + idCollection;
	}
}

function openWatchNowFromHome(videoId) {
    var isNativeRuntime = !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
    var isGuestUser = (typeof userData === 'undefined' || !userData || userData.status != 'success');
    if (isNativeRuntime && isGuestUser) {
        openModalLogin();
        return false;
    }
    if (videoId) {
        loadPageVideo(videoId);
    }
    return false;
}
